import { useContext } from "react";
import TableFetchContext from "./TableFetchContext";
const useTableFetchContext = (skip = false) => {
  const tableFetchContext = useContext(TableFetchContext);
  if (skip) return {};
  if (!tableFetchContext) {
    throw new Error("useTableFetchContext hook needs to be used inside TableFetchContext.Provider");
  }
  return tableFetchContext;
};
export default useTableFetchContext;
